import callApi from 'helpers/callApi'

const parseJsonResponse = async (response) => {
	try {
		return await response.json()
	} catch {
		return null
	}
}

const fetchReportCalendarEndpoint = async (label, endpoint, params = {}) => {
	const response = await callApi(endpoint, 'GET', params)
	const payload = await parseJsonResponse(response)

	if (!response.ok) {
		console.error(`[ReportCalendar] ${label}`, {
			status: response.status,
			error: response.errorMessage,
			payload,
		})
		throw new Error(response.errorMessage || `Failed to load ${label}`)
	}

	return payload
}

export const fetchReportCalendarMonth = (params) => (
	fetchReportCalendarEndpoint(
		'calendar',
		'/dashboard/reporting_calendar/calendar',
		params,
	)
)

export const fetchReportCalendarTimeline = (params) => (
	fetchReportCalendarEndpoint(
		'timeline',
		'/dashboard/reporting_calendar/timeline',
		params,
	)
)

export const fetchReportCalendarUpcoming = (params) => (
	fetchReportCalendarEndpoint(
		'upcoming',
		'/dashboard/reporting_calendar/upcoming',
		params,
	)
)

export const fetchReportCalendarFilters = () => (
	fetchReportCalendarEndpoint(
		'filters',
		'/dashboard/reporting_calendar/filters',
		{},
	)
)
